export default __webpack_public_path__ + "static/media/qrcodeIcon.afe18040.svg";